var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 5,
    viewBox: "0 0 23 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.37698,
    cy: 2.37698,
    r: 2.37698,
    fill: "#58585E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.0926,
    cy: 2.37698,
    r: 2.37698,
    fill: "#58585E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.8081,
    cy: 2.37698,
    r: 2.37698,
    fill: "#58585E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/options.6e726abbffa7b52ab17b95abdd3f3c9a.svg";
export { ForwardRef as ReactComponent };